import React from 'react';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import AddIcon from '@mui/icons-material/Add';

function TemplateLibraryTable({ mode, templates, onPreview, onUseTemplate }) {
  return (
    <section
      style={{
        border: `1px solid ${mode === 'dark' ? '#363636' : '#e4e6e8'}`,
        borderRadius: 12,
        background: mode === 'dark' ? '#141414' : '#fff',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          padding: '12px 14px',
          fontWeight: 600,
          color: mode === 'dark' ? '#fff' : '#222',
          borderBottom: `1px solid ${mode === 'dark' ? '#2f2f2f' : '#eceff1'}`,
        }}
      >
        Digital form library
      </div>
      <div style={{ maxHeight: 560, overflowY: 'auto', overflowX: 'auto' }}>
        <table
          style={{
            width: '100%',
            minWidth: 760,
            borderCollapse: 'collapse',
          }}
        >
          <thead>
            <tr style={{ background: mode === 'dark' ? '#1b1b1b' : '#f8fafc' }}>
              <th style={{ ...headerCellStyle(mode), width: '28%' }}>Template Title</th>
              <th style={{ ...headerCellStyle(mode), width: '36%' }}>Description</th>
              <th style={{ ...headerCellStyle(mode), width: '10%', textAlign: 'center' }}>Fields</th>
              <th style={{ ...headerCellStyle(mode), width: '12%' }}>Status</th>
              <th style={{ ...headerCellStyle(mode), width: '14%', textAlign: 'center' }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {templates.map((template) => {
              const schema = Array.isArray(template.schema_json) ? template.schema_json : [];
              return (
                <tr key={template.id}>
                  <td style={bodyCellStyle(mode, '600')}>{template.title || `Template ${template.id}`}</td>
                  <td style={descriptionCellStyle(mode)}>
                    <div
                      style={descriptionClampStyle()}
                      title={template.description || 'No description'}
                    >
                      {template.description || 'No description'}
                    </div>
                  </td>
                  <td style={{ ...bodyCellStyle(mode), textAlign: 'center' }}>{schema.length}</td>
                  <td style={bodyCellStyle(mode)}>
                    <span
                      style={{
                        display: 'inline-block',
                        borderRadius: 999,
                        padding: '4px 10px',
                        fontSize: 12,
                        fontWeight: 600,
                        color: template.is_active ? '#067647' : '#b42318',
                        background: template.is_active ? '#ecfdf3' : '#fef3f2',
                      }}
                    >
                      {template.is_active ? 'Active' : 'Inactive'}
                    </span>
                  </td>
                  <td style={{ ...bodyCellStyle(mode), textAlign: 'center' }}>
                    <div style={{ display: 'inline-flex', gap: 8 }}>
                      <button
                        type="button"
                        title="Preview template"
                        onClick={() => onPreview(template)}
                        style={iconButtonStyle(mode)}
                      >
                        <VisibilityOutlinedIcon style={{ fontSize: 18 }} />
                      </button>
                      <button
                        type="button"
                        title="Use template"
                        onClick={() => onUseTemplate(template)}
                        style={iconButtonStyle(mode)}
                      >
                        <AddIcon style={{ fontSize: 18 }} />
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </section>
  );
}

const headerCellStyle = (mode) => ({
  textAlign: 'left',
  padding: '12px 14px',
  fontSize: 12,
  fontWeight: 700,
  letterSpacing: 0.3,
  color: mode === 'dark' ? '#d0d5dd' : '#475467',
  borderBottom: `1px solid ${mode === 'dark' ? '#2f2f2f' : '#eceff1'}`,
});

const bodyCellStyle = (mode, fontWeight = 500) => ({
  padding: '12px 14px',
  fontSize: 13,
  fontWeight,
  color: mode === 'dark' ? '#e4e7ec' : '#344054',
  borderBottom: `1px solid ${mode === 'dark' ? '#252525' : '#f0f1f3'}`,
  verticalAlign: 'middle',
});

const descriptionCellStyle = (mode) => ({
  ...bodyCellStyle(mode),
  whiteSpace: 'normal',
  wordBreak: 'break-word',
  verticalAlign: 'top',
});

const descriptionClampStyle = () => ({
  display: '-webkit-box',
  WebkitLineClamp: 3,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  lineHeight: 1.45,
  maxHeight: '4.35em',
});

const iconButtonStyle = (mode) => ({
  border: `1px solid ${mode === 'dark' ? '#3f3f3f' : '#d0d5dd'}`,
  borderRadius: 8,
  background: mode === 'dark' ? '#1d1d1d' : '#fff',
  color: mode === 'dark' ? '#e4e7ec' : '#344054',
  width: 34,
  height: 34,
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export default TemplateLibraryTable;
